import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This policy describes how we at npm, Inc., the company behind npmjs.com
and the npm public registry, respond to claims that materials users
have submitted to our service infringe copyright.  `}</p>
    <p>{`npm follows GitHub's `}<a parentName="p" {...{
        "href": "https://docs.github.com/site-policy/content-removal-policies/dmca-takedown-policy"
      }}>{`Copyright - DMCA Takedown Policy`}</a>{`. Please carefully review that policy along with GitHub's `}<a parentName="p" {...{
        "href": "https://docs.github.com/en/site-policy/content-removal-policies/guide-to-submitting-a-dmca-takedown-notice"
      }}>{`Guide to Submitting a DMCA Takedown Notice`}</a>{` to determine if you should submit a DMCA takedown. `}</p>
    <p>{`If you are ready to submit a DMCA takedown notice, the fastest way to get a response is to enter your information and answer all the questions on GitHub's `}<a parentName="p" {...{
        "href": "https://github.com/contact/dmca"
      }}>{`Copyright claims form`}</a>{`. Be sure to select the option indicating that your claim involves content on npm.js.`}</p>
    <p>{`You can also send an email notification to `}<a parentName="p" {...{
        "href": "mailto:copyright@github.com."
      }}>{`copyright@github.com.`}</a>{` You may include an attachment if you like, but please also include a plain-text version of your letter in the body of your message.`}</p>
    <p>{`If you must send your notice by physical mail, you can do that too, but it will take substantially longer for us to receive and respond to it. Notices we receive via plain-text email have a much faster turnaround than PDF attachments or physical mail. If you still wish to mail us your notice, GitHub's physical address is:`}</p>
    <p>{`GitHub, Inc`}<br parentName="p"></br>{`
`}{`Attn: DMCA Agent`}<br parentName="p"></br>{`
`}{`88 Colin P Kelly Jr St`}<br parentName="p"></br>{`
`}{`San Francisco, CA. 94107  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      